import {call, put, takeLatest} from "redux-saga/effects";
import * as actions from "../action.constants";
import {
  saveUserProfile,
  saveUsersList,
  updateAdduserModal,
  updateAdduserModalData,
} from "../Actions/users.action";
import {
  createUser,
  deleteUser,
  editUser,
  getUserProfileAsync,
  getUsers,
  verifyPhoneNumberAsync,
} from "../AsyncActions/users.async";

function* getUserList(action = {}) {
  const {pageUrl = ""} = action;
  try {
    const response = yield call(getUsers, pageUrl);
    if (response) {
      yield put(saveUsersList(response?.data));
    }
  } catch (e) {
    return e;
  }
}

function* handleUserModalResponse() {
  yield put(updateAdduserModal(false));
  yield put(updateAdduserModalData({}));
}

function* createUserRequest(action = {}) {
  const {payload = {}, callback = () => {}} = action;
  try {
    const response = yield call(createUser, payload);
    if (response) {
      callback();
      yield call(handleUserModalResponse, response);
    }
  } catch (e) {
    return e;
  }
}

function* editUserRequest(action = {}) {
  const {payload = {}, callback = () => {}} = action;

  try {
    const response = yield call(editUser, payload);
    if (response) {
      yield call(handleUserModalResponse, response);
      callback(response.data);
    }
  } catch (e) {
    return e;
  }
}

function* deleteUserRequest(action = {}) {
  const {payload, callback = () => {}} = action;
  try {
    const response = yield call(deleteUser, payload);
    if (response) {
      callback();
    }
  } catch (e) {
    return e;
  }
}

function* getUserProfile() {
  try {
    const response = yield call(getUserProfileAsync);
    if (response.data?.data) {
      yield put(saveUserProfile(response.data.data));
    }
  } catch (e) {
    return e;
  }
}

function* verifyPhoneNumber(action) {
  const {payload, callback = () => {}} = action;

  try {
    const response = yield call(verifyPhoneNumberAsync, payload);
    if (response) {
      callback(response.data);
    }
  } catch (e) {
    return e;
  }
}

export function* sitesSaga() {
  yield takeLatest(actions.REQUEST_SEND_ADD_USER_DATA_SAGA, createUserRequest);
  yield takeLatest(actions.REQUEST_GET_USERS_LIST_SAGA, getUserList);
  yield takeLatest(actions.REQUEST_SEND_EDIT_USER_DATA_SAGA, editUserRequest);
  yield takeLatest(actions.REQUEST_DELETE_USER_SAGA, deleteUserRequest);
  yield takeLatest(actions.GET_USER_PROFILE, getUserProfile);
  yield takeLatest(actions.VERIFY_PHONE_NUMBER, verifyPhoneNumber);
}
